export const styles = {
  header: {
    background: '#FFFFFF',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  nonSortableHeader: {
    '&:hover': {
      color: 'inherit',
      cursor: 'default',
    },
  },
  disableBorderBottom: {
    borderBottom: '0px',
  },
  delayColumn: {
    width: '45%',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}
